import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = {
    defaultTab: { type: String, default: "preferences" }
  }

  connect() {
    this.initializeTabs()
  }

  initializeTabs() {
    const hash = window.location.hash.replace('#', '')

    if (hash && this.hasTabTarget) {
      const tabToOpen = this.tabTargets.find(tab => tab.dataset.tabId === hash)
      if (tabToOpen) {
        this.selectTab(tabToOpen)
        return
      }
    }

    const defaultTab = this.tabTargets.find(tab => tab.dataset.tabId === this.defaultTabValue)
    if (defaultTab) {
      this.selectTab(defaultTab)
    } else if (this.hasTabTarget) {
      this.selectTab(this.tabTargets[0])
    }
  }

  select(event) {
    event.preventDefault()
    const selectedTab = event.currentTarget
    this.selectTab(selectedTab)

    const tabId = selectedTab.dataset.tabId
    if (tabId) {
      history.replaceState(null, null, `#${tabId}`)
    }
  }

  selectTab(selectedTab) {
    const tabId = selectedTab.dataset.tabId

    this.tabTargets.forEach(tab => {
      if (tab === selectedTab) {
        tab.classList.remove("border-transparent", "text-gray-500", "hover:text-gray-700", "hover:border-gray-300")
        tab.classList.add("border-indigo-500", "text-indigo-600")
        tab.setAttribute("aria-selected", "true")
      } else {
        tab.classList.remove("border-indigo-500", "text-indigo-600")
        tab.classList.add("border-transparent", "text-gray-500", "hover:text-gray-700", "hover:border-gray-300")
        tab.setAttribute("aria-selected", "false")
      }
    })

    this.panelTargets.forEach(panel => {
      if (panel.dataset.tabId === tabId) {
        panel.classList.remove("hidden")
      } else {
        panel.classList.add("hidden")
      }
    })
  }
}
